import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import '../styles/auth.css';
import { securePost } from '../utils/apiClient';

const LoginPage = ({ onLoginSuccess }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const navigate = useNavigate();

   const handleLogin = async (e) => {
     e.preventDefault();
     setErrorMessage('');

     try {
       const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/auth/login`, {
         method: 'POST',
         credentials: 'include', // This is crucial for cookies
         headers: {
           'Content-Type': 'application/json',
         },
         body: JSON.stringify({
           username: username.trim(),
           password: password.trim()
         })
       });

       if (!response.ok) {
         const errorData = await response.json();
         throw new Error(errorData.error || 'Login failed');
       }

       const data = await response.json();
       onLoginSuccess(data.user);
       navigate('/home');
     } catch (error) {
       setErrorMessage(error.message);
     }
   };

  const handleHomeRedirect = () => {
    navigate('/home');
  };

  return (
    <div className="auth-container">
      <div className="auth-box">
        <h2>Login</h2>
        {errorMessage && <p className="error-message">{errorMessage}</p>}
        <form onSubmit={handleLogin}>
          <div>
            <label htmlFor="username">Korisničko ime:</label>
            <input
              type="text"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoComplete="username"
              required
            />
          </div>
          <div>
            <label htmlFor="password">Šifra:</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              required
            />
          </div>
          <button type="submit">Uloguj se</button>
        </form>
        <div className="register-link">
          <p>Nemate nalog? <Link to="/register">Registrujte se ovde</Link></p>
          <p><Link to="/forgot-password">Zaboravili ste lozinku?</Link></p>
        </div>
        <div className="home-redirect">
          <button
            type="button"
            onClick={handleHomeRedirect}
            className="home-button"
          >
            Vrati se na početnu stranicu
          </button>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;